/* nunito weights */
import "@fontsource/nunito";
import "@fontsource/nunito/800.css";
import "@fontsource/nunito/900.css";

import styles from "./style.module.scss";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Modal from "react-modal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import DisableScreen from "src/modules/onboarding/views/DisableScreen";

Modal.setAppElement("#root");

const App = () => {
  return (
    <div className={styles.App}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DisableScreen />} />
        </Routes>
      </BrowserRouter>

      <ToastContainer />
    </div>
  );
};

export default App;
